// extracted by mini-css-extract-plugin
export default {"item":"AlarmItem_item__GAohy","last_item":"AlarmItem_last_item__ujlJ5"};